export default function MoveUpDownData(input, editMode) {
  const { position, index, selectedMovieOrPersonData, allTaggedPersons } = input

  // swap index with index+1 if position is down
  // swap index with index-1 if position is up
  const selectedMovieOrPersonDataTemp = [...selectedMovieOrPersonData]
  const taggedPersonsTemp = [...allTaggedPersons]
  if (position === 'up') {
    if (index !== 0) {
      const tempData = selectedMovieOrPersonDataTemp[index - 1]
      selectedMovieOrPersonDataTemp[index - 1] = selectedMovieOrPersonDataTemp[index]
      selectedMovieOrPersonDataTemp[index] = tempData
      if (editMode !== 'edit') {
        const taggedtemp = taggedPersonsTemp[index - 1]
        taggedPersonsTemp[index - 1] = taggedPersonsTemp[index]
        taggedPersonsTemp[index] = taggedtemp
      }
    }
  } else if (index !== selectedMovieOrPersonDataTemp.length - 1) {
    const tempData = selectedMovieOrPersonDataTemp[index + 1]
    selectedMovieOrPersonDataTemp[index + 1] = selectedMovieOrPersonDataTemp[index]
    selectedMovieOrPersonDataTemp[index] = tempData
    if (editMode !== 'edit') {
      const taggedtemp = taggedPersonsTemp[index + 1]
      taggedPersonsTemp[index + 1] = taggedPersonsTemp[index]
      taggedPersonsTemp[index] = taggedtemp
    }
  }

  return [selectedMovieOrPersonDataTemp, taggedPersonsTemp]
  // setSelectedMovieOrPersonData(selectedMovieOrPersonDataTemp)
  // setAllTaggedPersons(taggedPersonsTemp)
}
